<template>
    <div>
        <video id="myVideo" playsinline class="video-js vjs-default-skin" type="video/mp4">
            <p class="vjs-no-js">
                To view this video please enable JavaScript, or consider upgrading to a
                web browser that
                <a href="https://videojs.com/html5-video-support/" target="_blank">
                    supports HTML5 video.
                </a>
            </p>
        </video>
        <br>
        <button type="button" v-if="Start" class="btn btn-danger" @click.prevent="startRecording()"  id="btnStart">Mulai Merekam</button>
         <button type="button" v-if="Stop" class="btn btn-danger" @click.prevent="stopRecording()"  id="btnStop">Stop Merekam</button>
        <button type="button" v-if="Upload" class="btn btn-success" @click.prevent="submitVideo()"  id="btnSave">Sisipkan Video</button>
        
    </div>
</template>

<script>
import 'video.js/dist/video-js.css'
import 'videojs-record/dist/css/videojs.record.css'
import videojs from 'video.js'
import 'webrtc-adapter'
import RecordRTC from 'recordrtc'
import Record from 'videojs-record/dist/videojs.record.js'

//import FFmpegWasmEngine from 'videojs-record/dist/plugins/videojs.record.ffmpeg-wasm.js';

export default {
    props: ['uploadUrl'],
    data() {
        return {
            player: '',
            retake: 0,
            Start:true,
            Stop:false,
            Upload:false,
            isSaveDisabled: true,
            isStartRecording: false,
            isRetakeDisabled: true,
            //submitText: 'Submit',
            options: {
                controls: true,
                bigPlayButton: false,
                controlBar: {
                    deviceButton: false,
                    recordToggle: false,
                },
               
                
                width: 500,
                height: 300,
                fluid: true,
                plugins: {
                    record: {
                        pip: false,
                        audio: true,
                        video: true,
                        maxLength: 50,
                        debug: true,
                        hotKeys:true,

                        //videoMimeType : 'video/webm;codecs=h264',
                        // convertEngine: 'ffmpeg.wasm',
                        // convertWorkerURL: '../../../node_modules/@ffmpeg/core/dist/ffmpeg-core.js',
                        // // convert recorded data to MP4 (and copy over audio data without encoding)
                        // convertOptions: ['-c:v', 'libx264', '-preset', 'slow', '-crf', '22', '-c:a', 'copy', '-f', 'mp4'],
                        // // specify output mime-type
                        // pluginLibraryOptions: {
                            // outputType: 'video/mp4'
                        // }
                    }
                }
            }
        }
    },
    mounted() {
        this.player = videojs('myVideo', this.options, () => {
            // print version information at startup
            // var msg = 'Using video.js ' + videojs.VERSION +
            //     ' with videojs-record ' + videojs.getPluginVersion('record') +
            //     ' and recordrtc ' + RecordRTC.version;
           // videojs.log(msg);
        });
        // error handling
        this.player.on('deviceReady', () => {
            this.player.record().start();
          //  console.log('device ready:');
        });
        this.player.on('deviceError', () => {
            console.log('device error:', this.player.deviceErrorCode);
        });
        this.player.on('error', (element, error) => {
            console.error(error);
        });
        // user clicked the record button and started recording
        this.player.on('startRecord', () => {
            console.log('started recording!');
        });
        // user completed recording and stream is available
        this.player.on('finishRecord', () => {
            // this.isSaveDisabled = false;
            // if(this.retake == 0) {
            //     this.isRetakeDisabled = false;
            // }
            // the blob object contains the recorded data that
            // can be downloaded by the user, stored on server etc.
            //console.log('finished recording: ', this.player.recordedData);
        });
    },
    methods: {
        startRecording() {
            this.Stop = true;
            this.Start = false;
            this.Upload = false;
            this.btnRecord = 'Mulai Merekam';
            this.player.record().getDevice();
        },
        stopRecording(){
             this.Stop = false;
             this.Start = true;
             this.Upload = true;
             this.player.record().stop();
        },
        makeid(length) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
              result += characters.charAt(Math.floor(Math.random() * 
         charactersLength));
           }
           return result;
        },
        submitVideo() {
             //const token = this.$cookies.get('token');
            // this.isSaveDisabled = true;
            // this.isRetakeDisabled = true;

            //this.player.record().stop();
             var filename = this.makeid(10);
             var filerec = new File([this.player.recordedData], filename+'.mp4',{ type:'video/mp4'});
           //  var data = this.player.recordedData;
              //console.log(filerec);
            // this.submitText = "Upload Complete";

           this.$emit('record', filerec);
           
        },
        // retakeVideo() {
        //     this.isSaveDisabled = true;
        //     this.isRetakeDisabled = true;
        //     this.retake += 1;
        //     this.player.record().start();
        // }
    },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose();
        }
    }
}
</script>